<template>
  <div>
    <czrzck />
  </div>
</template>

<script>
// 获取接口地址
import czrzck from '@/components/rizhi/czrz'

export default {
  name: 'Czrz',
  components: {
    // sideMenu,
    // Header
    czrzck
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
